import { Menu, UnstyledButton } from '@mantine/core';
// icons
import { EllipsisVertical, Edit, Trash2 } from 'lucide-react';
// utils
import { MENU_PORTAL } from '@/const';

interface ContextMenuProps {
    onEdit: () => void;
    onDelete: () => void;
}

const ContextMenu = ({ onEdit, onDelete }: ContextMenuProps) => (
    <Menu
        withArrow
        withinPortal
        portalProps={{
            target: `#${MENU_PORTAL}`
        }}
    >
        <Menu.Target>
            <UnstyledButton>
                <EllipsisVertical />
            </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
            <Menu.Item leftSection={<Edit />} onClick={onEdit}>
                Edit
            </Menu.Item>
            <Menu.Item
                className="text-red-6"
                leftSection={<Trash2 />}
                onClick={onDelete}
            >
                Delete
            </Menu.Item>
        </Menu.Dropdown>
    </Menu>
);

export default ContextMenu;
